import $ from "jquery";
import { HandySvg } from "handy-svg";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import iconPointerLeft from "../../assets/icons/svg-sprite/point-arrow-left.svg";
import iconCross from "../../assets/icons/svg-sprite/close-cross--small.svg";
import iconAttention from "../../assets/icons/svg-sprite/attention.svg";
import { selects } from "../../lib/select/initSelectize";
import Aside from "../../components/aside/Aside";
import { user } from "../../lib/api/api";
import focusOutside from "../../modules/focus-outside";
import closeBanner from "../../modules/close-banner";
import fixedMessage from "../../modules/fixed-message";

const options = {
  locale: {
    ...Russian,
    months: {
      ...Russian.months,
      longhand: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
    },
  },
  dateFormat: "d-m-Y",
  monthSelectorType: "static",
  altFormat: "d.m.Y",
  altInput: true,
};

const UserProfile = ({ message, setMessage }) => {
  const [personalInfo, setPersonalInfo] = useState({});
  const [birthday, setBirthday] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    selects.userProfile();
    const selectizeControl = $("#profile_sex")[0].selectize;
    focusOutside();
    submitForm();
    closeBanner();
    fixedMessage();
    user
      .userInfo()
      .then((res) => {
        if (res.sex === 1) {
          selectizeControl.setValue("Мужской");
        } else if (res.sex === 2) {
          selectizeControl.setValue("Женский");
        }
        setPersonalInfo(res);
        setBirthday(changeOfDate(res.dob));
        setLoading(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function changeOfDate(date) {
    return `${date.slice(8, 10)}-${date.slice(5, 7)}-${date.slice(0, 4)}`;
  }

  function submitForm() {
    const formElement = document.getElementById("userForm");
    formElement.addEventListener("submit", (e) => {
      e.preventDefault();
      const formData = new FormData(formElement);
      const banner = document.getElementById("messageBanner");
      user
        .dataChange(
          formData.get("name_1"),
          formData.get("name_2"),
          formData.get("name_3"),
          formData.get("dob").replace(/-/g, "."),
          formData.get("sex") === "Мужской"
            ? 1
            : formData.get("sex") === "Женский"
              ? 2
              : "",
        )
        .then((res) => {
          if (res.error) {
            setErrors(res.reason);
            banner.style.display = "none";
          } else {
            setErrors({});
            banner.style.removeProperty("display");
            setMessage("Данные успешно изменены!");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  return (
    <>
      {!loading && <div className="preloader__wrapper" />}
      <div
        className="content__article-wrap"
        style={loading ? {} : { overflow: "hidden", height: "0px", margin: 0 }}
      >
        <article className="step-process-article">
          <div className="step-process-article__inner content-columns page-container">
            <div className="step-process-article__main content-columns__main js-section">
              <div className="cart__header">
                <div className="cart__header-inner">
                  <Link className="cart__return" to="/">
                    <HandySvg
                      className="svg-icon cart__return-icon"
                      src={iconPointerLeft}
                      width="18"
                      height="10"
                    />
                    <span className="cart__return-text">
                      Вернуться на главную
                    </span>
                  </Link>
                  <h1 className="cart__title title title--h2">
                    Профайл пользователя
                  </h1>
                </div>
              </div>
              <div className="wysiwyg">
                <p style={{ marginBottom: 30 }}>
                  Эти данные будут использоваться для анализа и подбора полезных
                  услуг специально для вас, а также для связи в случае
                  необходимости.
                </p>
              </div>
              <form method="POST" id="userForm">
                <div className="form__line">
                  <div className="form__item form__item--md">
                    <label for="profile_name_1" className="label label--md">
                      Фамилия
                    </label>
                    <input
                      id="profile_name_1"
                      className={
                        "input input--md js-focus-outside" +
                        (errors.name_1 ? " has-error" : "")
                      }
                      type="text"
                      name="name_1"
                      value={personalInfo.name_1}
                      onChange={(e) => {
                        setPersonalInfo((prevState) => ({
                          ...prevState,
                          name_1: e.target.value,
                        }));
                      }}
                    />
                    <div className="personal-form__error-message form__error active">
                      {errors.name_1
                        ? errors.name_1.map((item) => `${item}`).join("")
                        : ""}
                    </div>
                  </div>
                  <div className="form__item form__item--md">
                    <label for="profile_name_2" className="label label--md">
                      Имя
                    </label>
                    <input
                      id="profile_name_2"
                      className={
                        "input input--md js-focus-outside" +
                        (errors.name_2 ? " has-error" : "")
                      }
                      type="text"
                      name="name_2"
                      value={personalInfo.name_2}
                      onChange={(e) => {
                        setPersonalInfo((prevState) => ({
                          ...prevState,
                          name_2: e.target.value,
                        }));
                      }}
                    />
                    <div className="personal-form__error-message form__error active">
                      {errors.name_2
                        ? errors.name_2.map((item) => `${item}`).join("")
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="form__line">
                  <div className="form__item form__item">
                    <label for="profile_name_3" className="label label--md">
                      Отчество
                    </label>
                    <input
                      id="profile_name_3"
                      className={
                        "input input--md js-focus-outside" +
                        (errors.name_3 ? " has-error" : "")
                      }
                      type="text"
                      name="name_3"
                      value={personalInfo.name_3}
                      onChange={(e) => {
                        setPersonalInfo((prevState) => ({
                          ...prevState,
                          name_3: e.target.value,
                        }));
                      }}
                    />
                    <div className="personal-form__error-message form__error active">
                      {errors.name_3
                        ? errors.name_3.map((item) => `${item}`).join("")
                        : ""}
                    </div>
                  </div>
                </div>
                <div className="form__line">
                  <div className="form__item form__item--md">
                    <label for="profile_dob" className="label label--md">
                      Дата рождения
                    </label>
                    <Flatpickr
                      id="profile_dob"
                      value={birthday}
                      name="dob"
                      className={
                        "input input--md js-focus-outside" +
                        (errors.dob ? " has-error" : "")
                      }
                      options={options}
                      onChange={() => {}}
                    />
                    <div className="personal-form__error-message form__error active">
                      {errors.dob
                        ? errors.dob.map((item) => `${item}`).join("")
                        : ""}
                    </div>
                  </div>
                  <div className="form__item form__item--md">
                    <label
                      for="profile_sex-selectized"
                      className="label label--md"
                    >
                      Пол
                    </label>
                    <div className="select js-select select--md js-gui-select">
                      <select
                        name="sex"
                        className="select__item selectized"
                        id="profile_sex"
                        placeholder="Не выбран"
                      >
                        <option></option>
                        <option>Мужской</option>
                        <option>Женский</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="wysiwyg">
                  <p className="text text--sub">
                    * Данные профайла пользователя не предоставляются третьим
                    лицам
                  </p>
                </div>
                <div className="form__line">
                  <button
                    className="solid-btn solid-btn--md solid-btn--blue bttn"
                    type="submit"
                  >
                    Сохранить
                  </button>
                </div>
                <div
                  id="messageBanner"
                  className="info-cards__message-container js-closing-banner js-fixed-message"
                  style={{ display: "none" }}
                >
                  <div className="info-cards__message">
                    <div className="info-cards__message-content">
                      <HandySvg
                        className="svg-icon"
                        src={iconAttention}
                        width="36"
                        height="36"
                      />
                      <div className="info-cards__message-text">{message}</div>
                    </div>
                    <button
                      className="js-close-btn info-cards__message-btn"
                      type="button"
                    >
                      <HandySvg
                        className="svg-icon"
                        src={iconCross}
                        width="13"
                        height="12"
                      />
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <aside
              className="common-article__aside content-columns__aside"
              style={{ marginTop: 50 }}
            >
              <div className="content-columns__aside-cell">
                <Aside />
              </div>
            </aside>
          </div>
        </article>
      </div>
    </>
  );
};

export default UserProfile;
